import React, { createContext, useContext, useEffect, useReducer } from "react";
import PrivateApi from "../services/PrivateApiService";

const StateContext = createContext({
    authenticated: false,
    user: null,
    loading: true,
    contactPerson: undefined,
    tooltipsTrigger: true,
    tooltips: [],
});


const DispatchContext = createContext(null);

const reducer = (state, { type, payload }) => {
    switch (type) {
        case 'LOGIN':
            localStorage.setItem("sidebarExpanded", JSON.stringify(true));
            localStorage.removeItem('contactPerson');
            return {
                ...state,
                authenticated: true,
                user: payload,
            };
        case 'LOGOUT':
            localStorage.removeItem('token');
            if (localStorage.getItem('qr') !== null || localStorage.getItem('qr') !== undefined) {
                localStorage.removeItem('qr');
            }
            return {
                ...state,
                authenticated: false,
                user: null,
            };
        case 'POPULATE':
            return {
                ...state,
                user: {
                    ...state.user,
                    ...payload,
                },
            };
        case 'POPULATE_CONTACT':
            localStorage.setItem('contactPerson', JSON.stringify(payload));
            return {
                ...state,
                contactPerson: payload,
            };
        case 'CLEAR_CONTACT':
            localStorage.removeItem('contactPerson');
            return {
                ...state,
                contactPerson: undefined,
            };
        case 'POPULATE_TOOLTIPS':
            return {
                ...state,
                tooltips: payload,
            }
        case 'TOOLTIPS_ON':
            localStorage.setItem('tooltipsTrigger', true);
            return {
                ...state,
                tooltipsTrigger: true,
            };
        case 'TOOLTIPS_OFF':
            localStorage.setItem('tooltipsTrigger', false);
            return {
                ...state,
                tooltipsTrigger: false,
            }
        case 'SET_TOOLTIPS_TRIGGER':
            return {
                ...state,
                tooltipsTrigger: payload,
            }
        case 'STOP_LOADING':
            return {
                ...state,
                loading: false,
            };
        default:
            throw new Error(`Unknown action type: ${type}`);
    }
};


export const AuthProvider = ({ children }) => {
    const [state, defaultDispatch] = useReducer(reducer, {
        user: null,
        authenticated: false,
        loading: true,
        contactPerson: undefined,
        tooltipsTrigger: false,
        tooltips: [],
    });

    const dispatch = ( type, payload ) => defaultDispatch({ type, payload });
    const API = new PrivateApi();

    useEffect(() => {
        const loadUser = async () => {
            try {
                const token = localStorage.getItem('token');
                if (token === null || token === undefined) {
                    return;
                }
                const res = await API.checkIsLoggedIn();
                if (res.data.id !== null) {
                    dispatch('LOGIN', res.data);
                }

                const savedContact = localStorage.getItem('contactPerson');
                dispatch('POPULATE_CONTACT', JSON.parse(savedContact));

                const savedTooltipsTrigger = localStorage.getItem('tooltipsTrigger');

                if (savedTooltipsTrigger === undefined) {
                    dispatch('TOOLTIPS_OFF');
                } else {
                    dispatch('SET_TOOLTIPS_TRIGGER', JSON.parse(savedTooltipsTrigger));
                }
                
                const tp = await API.get_Tooltips();
                dispatch('POPULATE_TOOLTIPS', tp.data);


            } catch (err) {
                localStorage.removeItem('token');
            } finally {
                dispatch('STOP_LOADING');
            }
        };
        loadUser();

        

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    /* useEffect(() => {
        if (data && data.data.length > 0) {
            dispatch('POPULATE_TOOLTIPS', data.data)
        }
    }, [data]) */

    return (
        <StateContext.Provider value={state}>
            <DispatchContext.Provider value={dispatch}>
                {children}
            </DispatchContext.Provider>
        </StateContext.Provider>
    );
};

export const useAuthState = () => useContext(StateContext);
export const useAuthDispatch = () => useContext(DispatchContext);